import InvoiceRemark from './InvoiceRemark';
import Styles from './RecentOrder.module.scss';

class RecentOrder extends InvoiceRemark {
    OrderID: number;
    ProcedureCode: string;
    OrderNumber: string;
    DateTimeImplementation: string;

    constructor(orderID: number, procedureCode: string, orderNumber: string, dateImplementation: string) {
        super();
        this.OrderID = orderID;
        this.ProcedureCode = procedureCode;
        this.OrderNumber = orderNumber;
        this.DateTimeImplementation = dateImplementation;
    }

    info(t: Function): React.ReactElement {
        return <a href={`/Orders/Detail/${this.OrderID}`} className={`${Styles.recentOrder} ajaxLinkNav`}>{t('Procedure')} {this.ProcedureCode} {t('In')} {t('Order')} #{this.OrderNumber} ({this.DateTimeImplementation})</a>;
    }
}

export default RecentOrder;
